import React from "react";

import { MenuItem, Select, useTheme } from "../ui-v2";

interface SortField {
  id: string;
  icon?: React.ReactElement;
  label: string;
}

interface SortFieldSelectProps {
  fields: SortField[];
  selected: string;
  onChange: (value: string) => void;
}

export const SortFieldSelect = (props: SortFieldSelectProps) => {
  const { fields, selected, onChange } = props;
  const selectedField = fields.find((field) => field.id === selected);
  const selectedLabel = selectedField?.label || "";
  const selectedId = selectedField?.id;

  const theme = useTheme();
  const { spacing } = theme;

  return (
    <Select
      value={selectedId}
      inputProps={{ "aria-label": "Sort by" }}
      onChange={(event) =>
        onChange(
          typeof event.target.value === "string" ? event.target.value : "",
        )
      }
      size="small"
      sx={{
        background: "transparent",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        maxHeight: spacing(7),
        marginLeft: "-1px",

        "& .MuiSelect-select.MuiInputBase-input.MuiFilledInput-input": {
          color: "secondary.2",
          paddingRight: "25px",
        },
      }}
      renderValue={() => selectedLabel}
    >
      {fields.map((field) => (
        <MenuItem key={field.id} value={field.id} icon={field.icon}>
          {field.label}
        </MenuItem>
      ))}
    </Select>
  );
};
